import React, { useState, useEffect } from 'react';
import styles from './FilterPricing.module.scss';
import { FormControl, MenuItem, Select, InputLabel } from '@material-ui/core';
import CustomButton from '../../../layout/customButton/CustomButton';
import { connect } from 'react-redux';

const FilterPricing = (props) => {
	const [lotSizeType, setLotSizeType] = useState('');
	const [unitId, setUnitId] = useState('');

	const {
		lots,
		buildingInfo,
		closePricingFilterModal,
		setFilteredLotSizeType,
		setFilteredUnit,
	} = props;

	const handleChange = (e) => {
		if (e.target.name === 'lotSizeType') {
			setLotSizeType(e.target.value);
		} else if (e.target.name === 'unitId') {
			setUnitId(e.target.value);
		}
	};

	const handleApply = () => {
		setFilteredLotSizeType(lotSizeType);
		setFilteredUnit(unitId);
		closePricingFilterModal();
	};

	return (
		<div className={styles.filter_pricing}>
			<FormControl variant='outlined' className={styles.select}>
				<InputLabel id='lot-size-type-label'>Lot Size</InputLabel>
				<Select
					labelId='lot-size-type-label'
					label='Lot Size'
					value={lotSizeType}
					name='lotSizeType'
					onChange={(e) => handleChange(e)}
				>
					<MenuItem value=''>None</MenuItem>
					<MenuItem value='50'>50'</MenuItem>
					<MenuItem value='70'>70'</MenuItem>
				</Select>
			</FormControl>
			<FormControl variant='outlined' className={styles.select}>
				<InputLabel id='unit-id-label'>Unit</InputLabel>
				<Select
					labelId='unit-id-label'
					label='Unit'
					value={unitId}
					name='unitId'
					onChange={(e) => handleChange(e)}
				>
					<MenuItem value=''>None</MenuItem>
					{buildingInfo &&
						Object.keys(buildingInfo).map((item, index) => (
							<MenuItem key={index} value={item}>
								{item}
							</MenuItem>
						))}
				</Select>
			</FormControl>
			<div className={styles.apply_btn}>
				<CustomButton width='166' height='42' onClick={handleApply}>
					Apply
				</CustomButton>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	buildingInfo: state.siteplanManagement.buildingInfo,
	lots: state.siteplanManagement.lots,
});
export default connect(mapStateToProps)(FilterPricing);
